/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssinarDocumentoDto,
  AtualizarRequisicaoDto,
  CompartilharDto,
  CompartilharPorEmailDto,
  CriarRequisicaoDto,
  ErroResponse,
  LinkCompartilhadoResponse,
  PaginaDeRequisicoesResponse,
  RequisicaoResponse,
  RequisicoesControllerListarParams
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getRequisicoesControllerListarUrl = (params?: RequisicoesControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/requisicoes-exames?${stringifiedParams}` : `/v1/requisicoes-exames`
}

/**
 * @summary Lista as requisições do ambiente
 */
export const requisicoesControllerListar = async (params?: RequisicoesControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeRequisicoesResponse> => {

  return httpClient<PaginaDeRequisicoesResponse>(getRequisicoesControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRequisicoesControllerListarQueryKey = (params?: RequisicoesControllerListarParams,) => {
    return [
    `/v1/requisicoes-exames`, ...(params ? [params] : [])
    ] as const;
    }


export const getRequisicoesControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof requisicoesControllerListar>>, TError = ErroResponse>(params?: RequisicoesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequisicoesControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof requisicoesControllerListar>>> = ({ signal }) => requisicoesControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RequisicoesControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof requisicoesControllerListar>>>
export type RequisicoesControllerListarQueryError = ErroResponse


export function useRequisicoesControllerListar<TData = Awaited<ReturnType<typeof requisicoesControllerListar>>, TError = ErroResponse>(
 params: undefined |  RequisicoesControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requisicoesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof requisicoesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequisicoesControllerListar<TData = Awaited<ReturnType<typeof requisicoesControllerListar>>, TError = ErroResponse>(
 params?: RequisicoesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requisicoesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof requisicoesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequisicoesControllerListar<TData = Awaited<ReturnType<typeof requisicoesControllerListar>>, TError = ErroResponse>(
 params?: RequisicoesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as requisições do ambiente
 */

export function useRequisicoesControllerListar<TData = Awaited<ReturnType<typeof requisicoesControllerListar>>, TError = ErroResponse>(
 params?: RequisicoesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRequisicoesControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRequisicoesControllerCriarUrl = () => {




  return `/v1/requisicoes-exames`
}

/**
 * @summary Cria a requisição com os itens. Nasce RASCUNHO, sem numeração.
 */
export const requisicoesControllerCriar = async (criarRequisicaoDto: CriarRequisicaoDto, options?: Parameters<typeof httpClient>[1]): Promise<RequisicaoResponse> => {

  return httpClient<RequisicaoResponse>(getRequisicoesControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarRequisicaoDto)
  }
);}





export const getRequisicoesControllerCriarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerCriar>>, TError,{data: CriarRequisicaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerCriar>>, TError,{data: CriarRequisicaoDto}, TContext> => {

const mutationKey = ['requisicoesControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requisicoesControllerCriar>>, {data: CriarRequisicaoDto}> = (props) => {
          const {data} = props ?? {};

          return  requisicoesControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequisicoesControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof requisicoesControllerCriar>>>
    export type RequisicoesControllerCriarMutationBody = CriarRequisicaoDto
    export type RequisicoesControllerCriarMutationError = unknown

    /**
 * @summary Cria a requisição com os itens. Nasce RASCUNHO, sem numeração.
 */
export const useRequisicoesControllerCriar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerCriar>>, TError,{data: CriarRequisicaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requisicoesControllerCriar>>,
        TError,
        {data: CriarRequisicaoDto},
        TContext
      > => {
      return useMutation(getRequisicoesControllerCriarMutationOptions(options), queryClient);
    }
    export const getRequisicoesControllerObterUrl = (id: string,) => {




  return `/v1/requisicoes-exames/${id}`
}

/**
 * @summary Detalha uma requisição com os itens
 */
export const requisicoesControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<RequisicaoResponse> => {

  return httpClient<RequisicaoResponse>(getRequisicoesControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRequisicoesControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/requisicoes-exames/${id}`
    ] as const;
    }


export const getRequisicoesControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof requisicoesControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequisicoesControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof requisicoesControllerObter>>> = ({ signal }) => requisicoesControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RequisicoesControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof requisicoesControllerObter>>>
export type RequisicoesControllerObterQueryError = ErroResponse


export function useRequisicoesControllerObter<TData = Awaited<ReturnType<typeof requisicoesControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requisicoesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof requisicoesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequisicoesControllerObter<TData = Awaited<ReturnType<typeof requisicoesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requisicoesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof requisicoesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequisicoesControllerObter<TData = Awaited<ReturnType<typeof requisicoesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha uma requisição com os itens
 */

export function useRequisicoesControllerObter<TData = Awaited<ReturnType<typeof requisicoesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRequisicoesControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRequisicoesControllerAtualizarUrl = (id: string,) => {




  return `/v1/requisicoes-exames/${id}`
}

/**
 * @summary Edita. `itens` substitui a lista inteira. Assinada responde 409.
 */
export const requisicoesControllerAtualizar = async (id: string,
    atualizarRequisicaoDto: AtualizarRequisicaoDto, options?: Parameters<typeof httpClient>[1]): Promise<RequisicaoResponse> => {

  return httpClient<RequisicaoResponse>(getRequisicoesControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarRequisicaoDto)
  }
);}





export const getRequisicoesControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerAtualizar>>, TError,{id: string;data: AtualizarRequisicaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerAtualizar>>, TError,{id: string;data: AtualizarRequisicaoDto}, TContext> => {

const mutationKey = ['requisicoesControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requisicoesControllerAtualizar>>, {id: string;data: AtualizarRequisicaoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  requisicoesControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequisicoesControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof requisicoesControllerAtualizar>>>
    export type RequisicoesControllerAtualizarMutationBody = AtualizarRequisicaoDto
    export type RequisicoesControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita. `itens` substitui a lista inteira. Assinada responde 409.
 */
export const useRequisicoesControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerAtualizar>>, TError,{id: string;data: AtualizarRequisicaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requisicoesControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarRequisicaoDto},
        TContext
      > => {
      return useMutation(getRequisicoesControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getRequisicoesControllerExcluirUrl = (id: string,) => {




  return `/v1/requisicoes-exames/${id}`
}

/**
 * @summary Exclusão lógica. Assinada responde 409.
 */
export const requisicoesControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getRequisicoesControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRequisicoesControllerExcluirMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['requisicoesControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requisicoesControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  requisicoesControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequisicoesControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof requisicoesControllerExcluir>>>

    export type RequisicoesControllerExcluirMutationError = unknown

    /**
 * @summary Exclusão lógica. Assinada responde 409.
 */
export const useRequisicoesControllerExcluir = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requisicoesControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRequisicoesControllerExcluirMutationOptions(options), queryClient);
    }
    export const getRequisicoesControllerPdfUrl = (id: string,) => {




  return `/v1/requisicoes-exames/${id}/pdf`
}

/**
 * @summary Gera o PDF. Assinada usa o SNAPSHOT congelado; rascunho usa o cadastro atual (prévia).
 */
export const requisicoesControllerPdf = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getRequisicoesControllerPdfUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRequisicoesControllerPdfQueryKey = (id: string,) => {
    return [
    `/v1/requisicoes-exames/${id}/pdf`
    ] as const;
    }


export const getRequisicoesControllerPdfQueryOptions = <TData = Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequisicoesControllerPdfQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof requisicoesControllerPdf>>> = ({ signal }) => requisicoesControllerPdf(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RequisicoesControllerPdfQueryResult = NonNullable<Awaited<ReturnType<typeof requisicoesControllerPdf>>>
export type RequisicoesControllerPdfQueryError = unknown


export function useRequisicoesControllerPdf<TData = Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requisicoesControllerPdf>>,
          TError,
          Awaited<ReturnType<typeof requisicoesControllerPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequisicoesControllerPdf<TData = Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requisicoesControllerPdf>>,
          TError,
          Awaited<ReturnType<typeof requisicoesControllerPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequisicoesControllerPdf<TData = Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gera o PDF. Assinada usa o SNAPSHOT congelado; rascunho usa o cadastro atual (prévia).
 */

export function useRequisicoesControllerPdf<TData = Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requisicoesControllerPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRequisicoesControllerPdfQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRequisicoesControllerAssinarUrl = (id: string,) => {




  return `/v1/requisicoes-exames/${id}/assinar`
}

/**
 * @summary Assina, atribui o número e CONGELA o paciente e o emissor em snapshot. Com certificado A1, o PDF sai assinado digitalmente (PAdES).
 */
export const requisicoesControllerAssinar = async (id: string,
    assinarDocumentoDto?: AssinarDocumentoDto, options?: Parameters<typeof httpClient>[1]): Promise<RequisicaoResponse> => {

  return httpClient<RequisicaoResponse>(getRequisicoesControllerAssinarUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assinarDocumentoDto)
  }
);}





export const getRequisicoesControllerAssinarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerAssinar>>, TError,{id: string;data?: AssinarDocumentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerAssinar>>, TError,{id: string;data?: AssinarDocumentoDto}, TContext> => {

const mutationKey = ['requisicoesControllerAssinar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requisicoesControllerAssinar>>, {id: string;data?: AssinarDocumentoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  requisicoesControllerAssinar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequisicoesControllerAssinarMutationResult = NonNullable<Awaited<ReturnType<typeof requisicoesControllerAssinar>>>
    export type RequisicoesControllerAssinarMutationBody = AssinarDocumentoDto | undefined
    export type RequisicoesControllerAssinarMutationError = ErroResponse

    /**
 * @summary Assina, atribui o número e CONGELA o paciente e o emissor em snapshot. Com certificado A1, o PDF sai assinado digitalmente (PAdES).
 */
export const useRequisicoesControllerAssinar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerAssinar>>, TError,{id: string;data?: AssinarDocumentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requisicoesControllerAssinar>>,
        TError,
        {id: string;data?: AssinarDocumentoDto},
        TContext
      > => {
      return useMutation(getRequisicoesControllerAssinarMutationOptions(options), queryClient);
    }
    export const getRequisicoesControllerCompartilharUrl = (id: string,) => {




  return `/v1/requisicoes-exames/${id}/compartilhar`
}

/**
 * @summary Gera link com prazo. Cada abertura fica registrada em documento_acessos.
 */
export const requisicoesControllerCompartilhar = async (id: string,
    compartilharDto: CompartilharDto, options?: Parameters<typeof httpClient>[1]): Promise<LinkCompartilhadoResponse> => {

  return httpClient<LinkCompartilhadoResponse>(getRequisicoesControllerCompartilharUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(compartilharDto)
  }
);}





export const getRequisicoesControllerCompartilharMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerCompartilhar>>, TError,{id: string;data: CompartilharDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerCompartilhar>>, TError,{id: string;data: CompartilharDto}, TContext> => {

const mutationKey = ['requisicoesControllerCompartilhar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requisicoesControllerCompartilhar>>, {id: string;data: CompartilharDto}> = (props) => {
          const {id,data} = props ?? {};

          return  requisicoesControllerCompartilhar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequisicoesControllerCompartilharMutationResult = NonNullable<Awaited<ReturnType<typeof requisicoesControllerCompartilhar>>>
    export type RequisicoesControllerCompartilharMutationBody = CompartilharDto
    export type RequisicoesControllerCompartilharMutationError = ErroResponse

    /**
 * @summary Gera link com prazo. Cada abertura fica registrada em documento_acessos.
 */
export const useRequisicoesControllerCompartilhar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerCompartilhar>>, TError,{id: string;data: CompartilharDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requisicoesControllerCompartilhar>>,
        TError,
        {id: string;data: CompartilharDto},
        TContext
      > => {
      return useMutation(getRequisicoesControllerCompartilharMutationOptions(options), queryClient);
    }
    export const getRequisicoesControllerCompartilharPorEmailUrl = (id: string,) => {




  return `/v1/requisicoes-exames/${id}/compartilhar/email`
}

/**
 * @summary Envia a requisição ao tutor por e-mail, com o PDF anexo
 */
export const requisicoesControllerCompartilharPorEmail = async (id: string,
    compartilharPorEmailDto: CompartilharPorEmailDto, options?: Parameters<typeof httpClient>[1]): Promise<LinkCompartilhadoResponse> => {

  return httpClient<LinkCompartilhadoResponse>(getRequisicoesControllerCompartilharPorEmailUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(compartilharPorEmailDto)
  }
);}





export const getRequisicoesControllerCompartilharPorEmailMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerCompartilharPorEmail>>, TError,{id: string;data: CompartilharPorEmailDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerCompartilharPorEmail>>, TError,{id: string;data: CompartilharPorEmailDto}, TContext> => {

const mutationKey = ['requisicoesControllerCompartilharPorEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requisicoesControllerCompartilharPorEmail>>, {id: string;data: CompartilharPorEmailDto}> = (props) => {
          const {id,data} = props ?? {};

          return  requisicoesControllerCompartilharPorEmail(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequisicoesControllerCompartilharPorEmailMutationResult = NonNullable<Awaited<ReturnType<typeof requisicoesControllerCompartilharPorEmail>>>
    export type RequisicoesControllerCompartilharPorEmailMutationBody = CompartilharPorEmailDto
    export type RequisicoesControllerCompartilharPorEmailMutationError = ErroResponse

    /**
 * @summary Envia a requisição ao tutor por e-mail, com o PDF anexo
 */
export const useRequisicoesControllerCompartilharPorEmail = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requisicoesControllerCompartilharPorEmail>>, TError,{id: string;data: CompartilharPorEmailDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requisicoesControllerCompartilharPorEmail>>,
        TError,
        {id: string;data: CompartilharPorEmailDto},
        TContext
      > => {
      return useMutation(getRequisicoesControllerCompartilharPorEmailMutationOptions(options), queryClient);
    }
